import React from "react";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../../../pages/PageNotFound";
import Login from "../../../pages/AdminLogin/Login";
import NewOrdersCount from '../../../pages/Admin/NewOrdersCount/NewOrdersCount';
import TotalMailcount from '../../../pages/Admin/TotalMailCount/TotalMailCount';
import DomainsTotalMails from '../../../pages/Admin/DomainsTotalMails/DomainsTotalMails';
import DomainsMailCount from '../../../pages/Admin/DomainsMailCount/DomainsMailCount';
import DomainList from "../../../pages/Admin/DomainList";
import LandingList from "../../../pages/Admin/LandingList";
import SingleDomainList from "../../../pages/Admin/SingleDomainList";

const Main = (props) => {
  return (
    <main>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/admin" element={<NewOrdersCount />} />
        <Route path="/total-mail-count" element={<TotalMailcount />} />
        <Route path="/total-domains" element={<DomainsTotalMails />} />
        <Route path="/domain-list-mail/:id" element={<DomainsMailCount />} />
        {/* <Route path="/domainlist" element={<DomainList />} />
        <Route path="/landinglist" element={<LandingList />} />
        <Route path="/domain-list/:id" element={<SingleDomainList />} /> */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </main>
  );
};

export default Main;
